import { HttpClient, HttpParams } from '@angular/common/http';
import { DomainService } from './domain-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./domain-service";
var ClaimService = /** @class */ (function () {
    function ClaimService(http, domainService) {
        this.http = http;
        this.domainService = domainService;
    }
    /**
     * Listado paginado de las consultas de siniestros del usuario logado.
     *
     * @param pageOffset desplazamiento de página (0-based)
     * @param pageSize tamaño de página
     */
    ClaimService.prototype.list = function (pageOffset, pageSize) {
        var httpParams = new HttpParams();
        httpParams = httpParams.append('pageOffset', pageOffset.toString());
        httpParams = httpParams.append('pageSize', pageSize.toString());
        var url = this.domainService.backendUrlWithContext + '/claims/list';
        return this.http.get(url, { params: httpParams }).toPromise();
    };
    /**
     * Listado completo (sin paginar) de las consultas de siniestros del usuario logado.
     * Solicita una página lo bastante grande para traer todas las consultas.
     */
    ClaimService.prototype.listAll = function () {
        return this.list(0, 1000);
    };
    ClaimService.ngInjectableDef = i0.defineInjectable({ factory: function ClaimService_Factory() { return new ClaimService(i0.inject(i1.HttpClient), i0.inject(i2.DomainService)); }, token: ClaimService, providedIn: "root" });
    return ClaimService;
}());
export { ClaimService };
